// Generated by CoffeeScript 1.10.0
(function() {
  var inherit, uniqueMembers,
    hasProp = {}.hasOwnProperty;

  uniqueMembers = function(content) {
    var i, key, known;
    known = {};
    i = 0;
    while (i < content.length) {
      if (content[i].element === 'member') {
        key = content[i].content.key.content;
        if (known[key] !== void 0) {
          content[known[key]] = content[i];
          content.splice(i, 1);
          continue;
        } else {
          known[key] = i;
        }
      }
      i++;
    }
    return content;
  };

  inherit = function(base, element) {
    var base1, base2, combined, item, j, k, key, len, len1, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, value;
    combined = JSON.parse(JSON.stringify(base));
    if (((ref = base.meta) != null ? ref.id : void 0) != null) {
      delete combined.meta.id;
      combined.meta.ref = base.meta.id;
      if ((base1 = combined.meta).links == null) {
        base1.links = [];
      }
      combined.meta.links.push({
        relation: 'origin',
        href: 'http://refract.link/inherited/'
      });
      if ((ref1 = combined.content) != null ? ref1.length : void 0) {
        ref2 = combined.content;
        for (j = 0, len = ref2.length; j < len; j++) {
          item = ref2[j];
          if (item.element) {
            if (!(item.meta && item.meta.ref)) {
              if (item.meta == null) {
                item.meta = {};
              }
              item.meta.ref = base.meta.id;
              if ((base2 = item.meta).links == null) {
                base2.links = [];
              }
              item.meta.links.push({
                relation: 'origin',
                href: 'http://refract.link/inherited-member/'
              });
            }
          }
        }
      }
    }
    if (element.meta) {
      if (combined.meta == null) {
        combined.meta = {};
      }
      ref3 = element.meta;
      for (key in ref3) {
        if (!hasProp.call(ref3, key)) continue;
        value = ref3[key];
        combined.meta[key] = value;
      }
    }
    if (element.attributes) {
      if (combined.attributes == null) {
        combined.attributes = {};
      }
      ref4 = element.attributes;
      for (key in ref4) {
        if (!hasProp.call(ref4, key)) continue;
        value = ref4[key];
        combined.attributes[key] = value;
      }
    }
    if (element.content) {
      if (((ref5 = combined.content) != null ? ref5.push : void 0) || ((ref6 = element.content) != null ? ref6.push : void 0)) {
        if (combined.content == null) {
          combined.content = [];
        }
        ref7 = element.content;
        for (k = 0, len1 = ref7.length; k < len1; k++) {
          item = ref7[k];
          combined.content.push(item);
        }
        if (combined.content.length && combined.content[0].element === 'member') {
          uniqueMembers(combined.content);
        }
      } else {
        if (element.content != null) {
          combined.content = element.content;
        }
      }
    }
    return combined;
  };

  module.exports = {
    uniqueMembers: uniqueMembers,
    inherit: inherit
  };

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/eidolon/lib/inherit.js
 ** module id = 163
 ** module chunks = 0
 **/